import { render, staticRenderFns } from "./per-car.vue?vue&type=template&id=9c99f658&scoped=true&"
import script from "./per-car.vue?vue&type=script&lang=js&"
export * from "./per-car.vue?vue&type=script&lang=js&"
import style0 from "./per-car.vue?vue&type=style&index=0&id=9c99f658&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c99f658",
  null
  
)

export default component.exports